import { gql } from 'graphql-request';

export const getTestConfiguration = gql`
  query GetTestConfiguration($id: String!) {
    test(id: $id) {
      id
      type
      name
      namespace
      resource {
        name
        type
      }
      tableAsset {
        id
        type
        name
        tableType
      }
      config {
        type
        muted
        ... on AnomalyDetectionTestConfig {
          anomaly_config: anomalyConfig {
            anomaly_direction: anomalyDirection
            detection_period: detectionPeriod {
              count
              period
            }
            sensitivity
            training_period: trainingPeriod {
              count
              period
            }
            excluded_time_ranges: excludedTimeRanges {
              start_time: startTime
              end_time: endTime
            }
            spike_threshold: spikeThreshold
            drop_threshold: dropThreshold
          }
          severity
          tags
          owners
        }
        ... on FreshnessAnomalyDetectionTestConfig {
          anomaly_config: anomalyConfig {
            sensitivity
            fixed_threshold: fixedThreshold {
              count
              period
            }
            training_period: trainingPeriod {
              count
              period
            }
            failure_threshold_grace: failureThresholdGrace {
              count
              period
            }
          }
          severity
          tags
          owners
        }
        ... on QueryTestConfig {
          config
          tags
          owners
          severity
          errorIf
          warnIf
          description
        }
        ... on YamlTestConfig {
          config
          tags
          owners
          severity
          errorIf
          warnIf
          description
        }
        ... on SourceFreshnessTestConfig {
          config
        }
        ... on DataContractTestConfig {
          enforcementLevel
          baselineColumns {
            columnName
            dataType
            isNullable
          }
        }
        ... on PipelineTaskPerformanceTestConfig {
          mode
          sensitivity
          training_period: trainingPeriod {
            count
            period
          }
          anomaly_direction: anomalyDirection
          fixed_threshold: fixedThreshold {
            count
            period
          }
          severity
          owners
          tags
        }
        ... on CustomSqlTestConfig {
          sql
          name
          schedule {
            type
            ... on CloudSqlTestEveryXHoursSchedule {
              interval_hours: intervalHours
            }
            ... on CloudSqlTestDailySchedule {
              hour
              minute
            }
            ... on CloudSqlTestWeeklySchedule {
              day_of_week: dayOfWeek
              hour
              minute
            }
            ... on CloudSqlTestCustomSchedule {
              cron
            }
          }
          sql_config: config {
            fail_row_count_threshold: failRowCountThreshold
            warn_row_count_threshold: warnRowCountThreshold
            store_row_sample: storeRowSample
            sample_row_limit: sampleRowLimit
            query_timeout_seconds: queryTimeoutSeconds
          }
          severity
        }
      }
    }
  }
`;

export const getTestConditionalAlertDestinations = gql`
  query GetTestConditionalAlertDestinations($id: String!) {
    test(id: $id) {
      conditionalAlertDestinations {
        id
        type
        channel
        configurationType
        ruleId
        conditions {
          statuses
        }
      }
    }
  }
`;
